<script setup lang="ts">
import { fieldPropDefs, useFieldProps } from './props';
import Editor from 'primevue/editor';
import Field from './Field.vue';

const props = defineProps({
    ...fieldPropDefs,
    noToolbar: {
        type: Boolean,
    },
});
const emit = defineEmits<{ (e: 'update:modelValue', value: string) }>();

const { id, name, fieldProps, modelValue } = useFieldProps(props, emit, {
    for: (id) => `${id}--full`,
});
</script>

<template>
    <Field v-bind="fieldProps">
        <template #readonly>
            <div class="ml-5">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <span v-html="modelValue ?? '-- geen waarde --'" />
            </div>
        </template>
        <Skeleton v-if="loading" />
        <Editor
            v-else
            v-bind="$attrs"
            :id="id"
            v-model="modelValue"
            :class="{ 'editor-no-toolbar': noToolbar }"
            :name="name"
            :scope="props.scope"
            :required="props.required"
        >
            <template #toolbar>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered" />
                    <button class="ql-list" value="bullet" />
                </span>
                <span class="ql-formats">
                    <button v-tooltip.bottom="'Bold'" class="ql-bold" />
                    <button v-tooltip.bottom="'Italic'" class="ql-italic" />
                    <button
                        v-tooltip.bottom="'Underline'"
                        class="ql-underline"
                    />
                    <button v-tooltip.bottom="'Strike'" class="ql-strike" />
                </span>
                <span class="ql-formats">
                    <button class="ql-script" value="sub" />
                    <button class="ql-script" value="super" />
                </span>
            </template>
        </Editor>
    </Field>
</template>

<style lang="scss">
.p-editor-container.editor-no-toolbar {
    .p-editor-toolbar {
        display: none;
    }
    .p-editor-content {
        border-radius: var(--border-radius);
        border-top: 1px solid var(--surface-border) !important;
        .ql-editor {
            border-radius: var(--border-radius);
        }
    }
}
</style>
